<template>
  <div class="house-importer-import-charges-stage-info-panel">
    <app-panel title="Сведение начислений">
      <div>
        <ul class="house-importer-import-charges-stage-info-panel__timeline">
          <li class="house-importer-import-charges-stage-info-panel__timeline-center">Сначала нужно исправить нормативные показания приборов: <app-button color="success" @click="fixValues" :disabled="isFixing">{{isFixing ? 'Исправляю' : 'Исправить'}}</app-button></li>
          <li>Перейти в основной интерфейс - для этого нужно определить активные тарифы  - это те, на которые есть начисления в последнем месяце, заполнить формулы и значения для этих тарифов</li>
          <li>Для тарифов отопления, тэ для гвс и тэ для гвс на одн изменить в настройках тарифа округление - поставить 4</li>
          <li class="house-importer-import-charges-stage-info-panel__timeline-center">Расчитать удельные значения для тарифов: <app-button color="success" @click="openSpecificValuesPopup">Расчитать</app-button></li>
          <li>Сгенерировать начисления на последний имеющийся в квартале месяц</li>
          <li class="house-importer-import-charges-stage-info-panel__timeline-center">Если в доме есть не только жилые помещения то после заполнения ВСЕХ тарифов на жилое нужно скопировать их на коммерческие помещения:  <app-button color="success" @click="askUserForCopyTariff" :disabled="isTariffsCopying">{{isTariffsCopying ? 'Копирую...' : 'Скопировать'}}</app-button></li>

          <li>После завершения генерациии начислений - запустить проверку (проверять тарифы можно и по одиночке)</li>
          <li>
            <div class="house-importer-import-charges-stage-info-panel__cause-title">Если будут отличия - выяснить их причину:</div>

            <div class="house-importer-import-charges-stage-info-panel__cause">если тариф по приборам - проверить приборы аккаунта, соответствует ли потребление тому что в квартале, включить прибор если отключен, добавить показания равные последним имеющимся если у другого прибора того же типа на этот или прошлый месяц есть расчетные или нормативные</div>

            <div class="house-importer-import-charges-stage-info-panel__cause-example">
              <div class="house-importer-import-charges-stage-info-panel-cause-example">
                <div class="house-importer-import-charges-stage-info-panel-cause-example__header">
                  <div class="house-importer-import-charges-stage-info-panel-cause-example__header-icon">
                    <app-icon name="InfoIcon2" size="20px"/>
                  </div>
                  <span class="house-importer-import-charges-stage-info-panel-cause-example__header-text">Пример</span>
                </div>
                <div class="house-importer-import-charges-stage-info-panel-cause-example__content">
                  <p>Есть 2 прибора хвс:</p>
                  <table>
                    <thead>
                      <tr>
                        <th>Прибор</th>
                        <th>Месяц</th>
                        <th>Показание</th>
                        <th>is_standard</th>
                        <th>calculated</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>2019-12</td>
                        <td>5</td>
                        <td>false</td>
                        <td>false</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>2020-01</td>
                        <td>10</td>
                        <td>false</td>
                        <td>true</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>2020-02</td>
                        <td>15</td>
                        <td>false</td>
                        <td>true</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>2020-03</td>
                        <td>20</td>
                        <td>false</td>
                        <td>false</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>2019-12</td>
                        <td>10</td>
                        <td>false</td>
                        <td>false</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>2020-03</td>
                        <td>15</td>
                        <td>false</td>
                        <td>false</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>а в квартале начисление за хвс показывает расход 10,  в таком случае прибору 2 нужно создать расчетные показания на 2020-01 и 2020-02 равные показаниям за 2019-12</p>
                </div>
              </div>
            </div>

            <div class="house-importer-import-charges-stage-info-panel__cause">если тариф по площади - вычислить цену тарифа но основании квартала, возможно у нас значение тарифа не верное</div>
            <div class="house-importer-import-charges-stage-info-panel__cause">если по удельным значениям - рассчитать удельные значение на основе начислений квартала</div>
            <div class="house-importer-import-charges-stage-info-panel__cause">если судя по показаниям все должно быть нормально но начисление 0  - нажмите «восстановить прибор» потом «сохранить»</div>
            <div class="house-importer-import-charges-stage-info-panel__cause">если показания совершенно не понятные - открыть промежуточную базу и посмотреть показания прибора там/ команда парсинга средних и нормативов иногда отрабатывает не корректно</div>
            <div class="house-importer-import-charges-stage-info-panel__cause-example">
              <div class="house-importer-import-charges-stage-info-panel-cause-example">
                <div class="house-importer-import-charges-stage-info-panel-cause-example__header">
                  <div class="house-importer-import-charges-stage-info-panel-cause-example__header-icon">
                    <app-icon name="InfoIcon2" size="20px"/>
                  </div>
                  <span class="house-importer-import-charges-stage-info-panel-cause-example__header-text">Пример</span>
                </div>
                <div class="house-importer-import-charges-stage-info-panel-cause-example__content">
                  <div v-viewer="{movable: false}">
                    <img :src="require('../assets/example1.png')" alt="example" style="max-width: 100%" >
                  </div>
                  <p>в случае, если последние показания реально поданные и равны начальным показаниям прибора, ставим показания января = показаниям февраля и дату начала эксплуатации - 1 февраля</p>
                </div>
              </div>
            </div>

          </li>
          <li class="house-importer-import-charges-stage-info-panel__timeline-center">После редактирования приборов перед очередной генерацией начислений надо запустить обновление статуса приборов: <app-button color="success" :disabled="isUpdating" @click="updateDevicesStatus">{{isUpdating ? 'Обновляю...' : 'Обновить'}}</app-button></li>
          <li>Цикл проверки повторять до совпадения начислений в квартала и у нас</li>
          <li class="house-importer-import-charges-stage-info-panel__timeline-center">Если нет приборов учета тепла но есть начисления за отопление - нужно создать пустые приборы тепла: <app-button color="success" @click="openCreateHeaterDevicesPopup">Создать</app-button></li>
          <li class="house-importer-import-charges-stage-info-panel__timeline-center">Когда все совпадет - завершить импорт: <app-button color="success" :disabled="isFinishing" @click="askUserForFinish">{{isFinishing ? 'Завершаю...' : 'Завершить'}}</app-button></li>
        </ul>
      </div>
    </app-panel>
    <SpecificValuesPopup ref="specificValuesPopup" :importInfo="importInfo"/>
    <CreateHeaterDevicesPopup ref="createHeaterDevicesPopup" :importInfo="importInfo" @created="$emit('update-stage')"/>
  </div>
</template>

<script>
  import 'viewerjs/dist/viewer.css'
  import Viewer from 'v-viewer'
  import Vue from 'vue'
  Vue.use(Viewer)

  import InfoBlock from "../../import-sourse-stage/check-source-stage/components/InfoBlock";
  import SpecificValuesPopup from "../components/SpecificValuesPopup";
  import CreateHeaterDevicesPopup from "@/components/house-importer/import-charges-stage/components/CreateHeaterDevicesPopup";



  export default {
    name: "InfoPanel",
    components: {
      InfoBlock,
      SpecificValuesPopup,
      CreateHeaterDevicesPopup
    },
    props: {
      importInfo: {}
    },
    data(){
      return {
        isFixing: false,
        isUpdating: false,
        isFinishing: false,
        isCreating: false,
        isTariffsCopying: false,
      }
    },
    methods: {
      openSpecificValuesPopup(){
        this.$refs.specificValuesPopup.open();
      },
      askUserForCopyTariff(){
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Подтверждение',
          text: 'Уверены что нужно скопировать тарифы?',
          acceptText: 'Да',
          cancelText: 'Нет',
          accept: this.copyTariffs
        });
      },
      async copyTariffs(){
        this.isTariffsCopying = true;
        try{
          let {data} = await this.$http.post('import/houses/copy_tarifs', {import_id: this.importInfo.id});

          if(data === 'replicated'){
            this.$vs.notify({color: 'success', title: 'Тарифы скопированы'});
          }
          else{
            this.$vs.notify({color: 'danger', title: 'UNKNOWN ANSWER', text: data});
          }
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
        finally {
          setTimeout(() => {this.isTariffsCopying = false}, 300);
        }
      },
      askUserForFinish(){
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Подтверждение',
          text: 'Завершить?',
          acceptText: 'Да',
          cancelText: 'Нет',
          accept: this.finishImport
        });
      },
      async finishImport(){
        this.isFinishing = true;
        try{
          let {data} = await this.$http.put('import/houses/finish_import', {import_id: this.importInfo.id});

          if(data === 'finished'){
            this.$vs.notify({color: 'success', title: 'Импорт завершен'});
            this.$emit('update-stage');
          }
          else{
            this.$vs.notify({color: 'danger', title: 'UNKNOWN ANSWER', text: data});
          }
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
        finally {
          setTimeout(() => {this.isFinishing = false}, 300);
        }
      },
      async updateDevicesStatus(){
        this.isUpdating = true;
        try{
          let {data} = await this.$http.get('import/houses/actualize_devices_state', {params: {import_id: this.importInfo.id}});

          if(data === 'done'){
            this.$vs.notify({color: 'success', title: 'Успешное обновления', text: 'Статусы обновлены'});
          }
          else{
            this.$vs.notify({color: 'danger', title: 'UNKNOWN ANSWER', text: data});
          }
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
        finally {
          setTimeout(() => {this.isUpdating = false}, 300);
        }
      },
      async fixValues(){
        this.isFixing = true;
        try{
          let {data} = await this.$http.post('import/houses/parse_dev_vals', {import_id: this.importInfo.id});

          if(data === 'done'){
            this.$vs.notify({color: 'success', title: 'Успешное сохранение', text: 'Показания исправлены'});
          }
          else{
            this.$vs.notify({color: 'danger', title: 'UNKNOWN ANSWER', text: data});
          }
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
        finally {
          setTimeout(() => {this.isFixing = false}, 300);
        }
      },
      openCreateHeaterDevicesPopup(){
        this.$refs.createHeaterDevicesPopup.open();
      }
    }
  }
</script>

<style lang="scss">
  .house-importer-import-charges-stage-info-panel{
    &__timeline{
      border-left: 1px solid rgba(0, 0, 0, .2);
      margin-left: 5px;

      /*padding: 15px 0;*/

      li{
        padding-left: 15px;
        position: relative;
        line-height: 1.1;

        &{
          padding-bottom: 20px;
          padding-top: 20px;
        }


        &::before{
          content: "";
          border: 2px solid rgba(var(--app-primary), 1);
          background: #fff;
          left: -8.5px;
          position: absolute;
          top: 20px;
          width: 11px;
          height: 11px;
          border-radius: 50%;
        }
      }

      &-center{
        &::before{
          top: 50%!important;
          transform: translateY(-50%);
        }
      }
    }

    &__cause{
      padding-left: 20px;
      position: relative;

      &::before{
        content: "";
        height: 2px;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 10px;
        background: rgba(var(--app-content-color), 1);
        position: absolute;
      }

      &:not(:last-child){
        margin-bottom: 20px;
      }

      &-title{
        margin-bottom: 30px;
      }

      &-example{
        margin: 0 0 30px 20px;
      }
    }
  }

  .house-importer-import-charges-stage-info-panel-cause-example{
    border: 1px dashed rgba(0, 0, 0, .2);
    padding: 15px 10px;

    &__header{
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      color: rgba(var(--app-primary), 1);

      &-icon {
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }

      &-text {
        line-height: 1.1;
      }
    }

    &__content{
      padding-left: 15px;

      p{
        margin: 15px 0;
      }

      table{
        width: 100%;
        border-collapse: collapse;

        th{
          background: #f5f8fa;
          border: 1px solid rgba(0,0,0,.125);
          padding: 10px;
        }

        td{
          border: 1px solid rgba(0,0,0,.125);
          padding: 10px;
        }
      }
    }


  }
</style>
